import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { visuallyHidden } from '@mui/utils';
import { useState } from 'react';
import { useEffect } from 'react';
import { useCallback } from 'react';
import { Chip, Menu, MenuItem, Stack, TextField } from '@mui/material';
import useAxiosPrivate from '../../hooks/use-axios-private';
import Empty from '../../components/Empty';
import moment from 'moment';
import { useTheme } from '@emotion/react';
import { DateRange } from 'react-date-range';
import Badge from '@mui/material/Badge';


const headCells = [
    {
        id: 'job_id',
        numeric: true,
        disablePadding: false,
        label: 'Job Id',
    },
    {
        id: 'job_title',
        numeric: true,
        disablePadding: false,
        label: 'Job Title',
    },
    {
        id: 'file_count',
        numeric: true,
        disablePadding: false,
        label: 'Total Files',
    },
    {
        id: 'completed_files',
        numeric: true,
        disablePadding: false,
        label: 'Completed Files',
    },
    {
        id: 'status',
        numeric: true,
        disablePadding: false,
        label: 'Status',
    },
    {
        id: 'approved_by',
        numeric: true,
        disablePadding: false,
        label: 'Approved By',
    },
    {
        id: 'Editor_name',
        numeric: true,
        disablePadding: false,
        label: 'Editor Name',
    },

];

const DEFAULT_ROWS_PER_PAGE = 5;

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;

    const createSortHandler = (newOrderBy) => {
        onRequestSort(newOrderBy);
    };
    return (
        <TableHead>
            <TableRow sx={{ height: { xs: 65, xl: 70 } }}>
                {/* <TableCell padding="checkbox">
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </TableCell> */}
                {headCells.map((headCell, index) => (
                    <TableCell
                        key={index}
                        align={'center'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ whiteSpace: "nowrap" }}
                    >
                        {
                            headCell.id !== 'action'
                                ?
                                <TableSortLabel
                                    active={orderBy === headCell.id}
                                    direction={orderBy}
                                    onClick={() => createSortHandler(headCell.id)}
                                >
                                    {headCell.label}
                                    {orderBy === headCell.id && (
                                        <Box component="span" sx={visuallyHidden}>
                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                        </Box>
                                    )
                                    }
                                </TableSortLabel>
                                :
                                headCell.label
                        }
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    //  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    // orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const [showFilter, setShowFilter] = useState(false)
    const [toggleDatePicker, setToggleDatePicker] = useState(false)
    const { numSelected, onSearchChange, filterChange } = props
    const theme = useTheme()
    const [appliedFilter, setAppliedFilter] = useState("ALL")
    const [filterCondition, setFilterCondition] = useState(
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    )

    const onFilterChange = (e) => {
        if (e !== "CUSTOM") {
            setAppliedFilter(e)
        }
        if (e === "CUSTOM") {
            setToggleDatePicker(true)
            return
        }
        else if (e === "7DAYS") {
            const date = new Date()
            const currentDate = moment()
            const sevenDays = date.setDate(date.getDate() - 6)
            const last7Days = moment(sevenDays)
            const filterCondition = {
                startDate: moment.utc(last7Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_30_DAYS") {
            const date = new Date()
            const currentDate = moment()
            const thirtyDays = date.setDate(date.getDate() - 30)
            const last30Days = moment(thirtyDays)
            const filterCondition = {
                startDate: moment.utc(last30Days).format(),
                endDate: moment.utc(currentDate).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const month = date.setMonth(date.getMonth() - 1)
            const NumberOfDaysInMonth = new Date(month);
            const firstDay = new Date(currentYear, NumberOfDaysInMonth.getMonth(), 1);
            let lastDay = new Date(currentYear, NumberOfDaysInMonth.getMonth() + 1, 0);
            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "LST_3_MONTH") {
            const date = new Date()
            const currentYear = date.getFullYear()
            const setLast3Month = date.setMonth(date.getMonth() - 3)

            const setLastmonth = date.setMonth(date.getMonth() + 2)

            const lastMonth = new Date(setLastmonth);

            const last3Month = new Date(setLast3Month);

            const firstDay = new Date(currentYear, last3Month.getMonth(), 1);

            const lastDay = new Date(currentYear, lastMonth.getMonth() + 1, 0);

            const filterCondition = {
                startDate: moment.utc(firstDay).format(),
                endDate: moment.utc(lastDay).format(),
            }
            filterChange(filterCondition)
        }

        else if (e === "ALL") {
            const filterCondition = {
                startDate: '',
                endDate: '',
            }
            filterChange(filterCondition)
        }
        setShowFilter(false)
    }
    return (
        <>
            <Box>
                <Toolbar
                    sx={{

                        px: 2,
                        ...(numSelected > 0 && {
                            bgcolor: (theme) =>
                                alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                        }),
                        alignItems: { xs: 'end' }
                    }}
                >
                    {numSelected > 0 ? (
                        <Typography
                            sx={{ flex: '1 1 100%' }}
                            color="inherit"
                            variant="subtitle1"
                            component="div"
                        >
                            {numSelected} selected
                        </Typography>
                    ) : (
                        <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'start', md: 'end' }} justifyContent='space-between' sx={{ width: '100%', mt: { xs: 2, md: 0 } }}>
                            <Typography
                                sx={{ flex: '1 1 100%', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 18, xl: 20 }, fontWeight: 500 }}
                                id="tableTitle"
                                component="div"
                            >
                                Final Report
                            </Typography>

                            {/* <Stack spacing={2} direction={{ xs: 'column', sm: 'row' }} alignItems="end" justifyContent="end" sx={{ width: '100%' }}>
                                <Box sx={{ mr: 3, width: { xs: '100%', md: 300 }, maxWidth: '100%', pr: { xs: 0, sm: 2 } }}>
                                    <TextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={onSearchChange} autoComplete='off' />
                                </Box>
                            </Stack> */}
                        </Stack>
                    )}

                    {numSelected > 0 ? (
                        <>
                            <Tooltip title="Delete">
                                <IconButton color='error'>
                                    <DeleteOutlineOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Duplicate">
                                <IconButton>
                                    <ContentCopyOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit">
                                <IconButton>
                                    <EditOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ) : (
                        <>
                            {/* <Tooltip title="Filter">
                                <Badge overlap="circular" badgeContent=" " color="secondary" invisible={appliedFilter === 'ALL'} variant="dot">
                                    <IconButton sx={{ backgroundColor: '#f3f3f3' }} onClick={(e) => {
                                        setShowFilter(prev => {
                                            return prev ? false : e.target
                                        })
                                    }}>
                                        <FilterAltOutlinedIcon />
                                    </IconButton>
                                </Badge>
                            </Tooltip>

                            <Menu
                                open={showFilter}
                                anchorEl={showFilter}
                                onClose={() => { setShowFilter(false); setToggleDatePicker(false) }}
                            >
                                {toggleDatePicker ?
                                    <DateRange
                                        maxDate={new Date()}
                                        editableDateInputs={true}
                                        onChange={(item) => {
                                            setFilterCondition(item.selection)
                                            let nextDay = new Date(item.selection.endDate.getTime())
                                            nextDay.setHours(item.selection.endDate.getHours() + 24)
                                            let lastDate = moment.utc(item.selection.endDate).format()
                                            if (item.selection.startDate.getTime() === item.selection.endDate.getTime()) {
                                                lastDate = moment.utc(nextDay).format()
                                            }
                                            lastDate = moment(lastDate).set({ 'hour': 23, 'minute': 59, 'second': 59 })
                                            filterChange(
                                                {
                                                    startDate: moment.utc(item.selection.startDate).format(),
                                                    endDate: moment.utc(lastDate).format(),
                                                }
                                            )
                                            setAppliedFilter("CUSTOM")
                                        }}
                                        moveRangeOnFirstSelection={false}
                                        ranges={[filterCondition]}
                                    />
                                    :
                                    <Box>
                                        <MenuItem onClick={() => onFilterChange('ALL')} sx={appliedFilter === "ALL" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }} >All</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('7DAYS')} sx={appliedFilter === "7DAYS" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }}>Last 7 days</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_30_DAYS')} sx={appliedFilter === "LST_30_DAYS" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }}>Last 30 days</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_MONTH')} sx={appliedFilter === "LST_MONTH" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }}>Last month</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('LST_3_MONTH')} sx={appliedFilter === "LST_3_MONTH" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }}>Last 3 months</MenuItem>
                                        <MenuItem onClick={() => onFilterChange('CUSTOM')} sx={appliedFilter === "CUSTOM" && { background: "#ebecf0", borderLeft: "3px solid #0b1345", fontWeight: 500 }}>Custom range</MenuItem>
                                    </Box>
                                }
                            </Menu> */}
                        </>
                    )}
                </Toolbar>
            </Box>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const FinalReport = () => {
    const [ascorder, setAscorder] = useState("desc")
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
    const [paddingHeight, setPaddingHeight] = useState(0);
    const [searchText, setSearchText] = useState('');
    const [count, setCount] = useState(0);
    const axios = useAxiosPrivate()

    const [orderByReport, setOrderByReport] = useState([])
    const [report, setReport] = useState([])
    const [paymentInfo, setPaymentInfo] = useState({})
    const [filter, setFilter] = useState(
        {
            startDate: '',
            endDate: '',
            key: 'selection'
        }
    );

    const getReport = async () => {
        try {
            const resp = await axios.get("/reports/", {
                params: {
                    limit: rowsPerPage, search: searchText, page: page + 1
                    , order_by: orderByReport, order_by_type: ascorder,
                    start_date: filter.startDate,
                    end_date: filter.endDate,
                    only_final: 1,
                }
            })
            setReport(resp.data.data.report_list)
            setPaymentInfo(resp.data.data.page_info)
            setCount(resp.data.data.page_info.count)

        } catch (error) {

            console.error(error)
        }
    }
    useEffect(() => {
        getReport()
    }, [rowsPerPage, searchText, page, ascorder, orderByReport, filter]);


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
        setSelected([]);
    };
    const orderChange = (newOrderBy) => {
        if (newOrderBy === 'action') {
            return false
        }

        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByReport(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByReport(newOrderBy)
        }
    }


    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
            setPaddingHeight(0);
        }, []
    );
    return (

        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)" }}>
                <Box>
                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        onSearchChange={
                            (e) => {
                                setSearchText(e.target.value)
                            }
                        }
                        filterChange={
                            (e) => {
                                setFilter(e)
                            }
                        }
                        filter={filter}
                    />
                    {report.length > 0
                        ?
                        <>
                            <TableContainer>
                                <Table
                                    sx={{ minWidth: 750, mt: 3 }}
                                    aria-labelledby="tableTitle"
                                    size={"small"}
                                >
                                    <EnhancedTableHead
                                        numSelected={selected.length}
                                        //   order={order}
                                        //  orderBy={orderBy}
                                        onSelectAllClick={handleSelectAllClick}

                                        //  onRequestSort={orderChange}
                                        onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                        rowCount={report.length}
                                        orderBy={ascorder}
                                    />
                                    <TableBody>
                                        {report.map(row => {
                                            return (
                                                <React.Fragment>
                                                    <TableRow sx={{ height: { xs: 60, xl: 70 } }}>
                                                        <TableCell sx={{ whiteSpace: "pre-wrap" }} align="center">{row.job_id}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "pre-wrap", minWidth: "250px", maxWidth: "250px" }} align="center">{row.title}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.reports[0].total_files}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.reports[0].completed_files}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">
                                                            <Chip sx={{ textTransform: "capitalize" }}
                                                                label="Approved"
                                                                color="success"
                                                            >
                                                            </Chip>
                                                        </TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.reports[0].approved_user_name}</TableCell>
                                                        <TableCell sx={{ whiteSpace: "nowrap" }} align="center">{row.reports[0].reported_user_name}</TableCell>
                                                    </TableRow>
                                                </React.Fragment>
                                            )
                                        })}
                                        {paddingHeight > 0 && (
                                            <TableRow
                                                style={{
                                                    height: paddingHeight,
                                                }}
                                            >
                                                <TableCell colSpan={8} />
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={count}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                        :
                        <Empty sx={{ border: "none", }} icon={<DescriptionOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} text="No reports available" />
                    }
                </Box>
            </Paper>
        </Box>


    );
}

export default FinalReport